import { render, staticRenderFns } from "./joinedChallenge.vue?vue&type=template&id=2f5dfce7&scoped=true&"
import script from "./joinedChallenge.vue?vue&type=script&lang=js&"
export * from "./joinedChallenge.vue?vue&type=script&lang=js&"
import style0 from "./joinedChallenge.vue?vue&type=style&index=0&id=2f5dfce7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5dfce7",
  null
  
)

export default component.exports